import React from 'react'
import { useSelector } from 'react-redux'
import { makeStyles } from '@material-ui/core/styles'

import Chip from '@material-ui/core/Chip'

import quotaSelectors from 'store/selectors/quota'
import icons from '@nocode-works/template/icons'

const WarningIcon = icons.warning

const useStyles = makeStyles(theme => ({
  
}))

const QuotaWarning = ({
  
}) => {

  const classes = useStyles()

  const overQuotaWebsites = useSelector(quotaSelectors.websiteOverQuotaList)

  return overQuotaWebsites.length > 0 ? (
    <Chip
      icon={<WarningIcon />}
      label="Some of your websites are over the usage quota"
      color="secondary"
    />
  ) : null
}

export default QuotaWarning
